import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("zyro_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password, role = "user", referral_code = null, aadhaar_number = "") => {
    const { data } = await api.post("/auth/register", { name, email, password, role, referral_code, aadhaar_number });
    if (data.token) localStorage.setItem("zyro_token", data.token);
    setUser(data);
    return data;
  };

  const otpSend = async (phone) => {
    const { data } = await api.post("/auth/otp/send", { phone });
    return data;
  };

  const otpVerify = async (phone, otp, name) => {
    const { data } = await api.post("/auth/otp/verify", { phone, otp, name });
    if (data.token) localStorage.setItem("zyro_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("zyro_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, otpSend, otpVerify, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
